<template>
  <div>
    <div v-if="loading" class="has-text-centered py-5">
      <span class="icon is-large">
        <i class="material-icons spin">autorenew</i>
      </span>
      <p class="mt-2">Cargando información de Trade-In...</p>
    </div>

    <div v-else-if="tradeIn">
      <div class="notification is-info is-light mb-4" style="display: flex; align-items: center; justify-content: space-between;">
        <div>
          <p class="has-text-weight-bold is-size-6">Operación Trade-In #{{ tradeIn.id }}</p>
          <p class="is-size-7 mt-1">
            <span class="tag" :style="statusTagStyle">{{ tradeIn.logisticStatus }}</span>
          </p>
        </div>
        <router-link
          :to="'/trade-in/detalle/' + tradeIn.id"
          class="button is-info is-small"
        >
          <span class="material-icons" style="font-size: 16px; margin-right: 4px;">open_in_new</span>
          Ver operación completa
        </router-link>
      </div>

      <div class="columns">
        <div class="column is-6">
          <div class="box" style="border-left: 4px solid #3273dc;">
            <p class="has-text-weight-bold is-size-6 mb-2">
              <span class="material-icons" style="font-size: 16px; vertical-align: middle; margin-right: 4px; color: #3273dc;">smartphone</span>
              📦 Equipo Entregado (Trade-In)
            </p>
            <div class="is-flex is-align-items-center mb-3" v-if="mainTradeInImage">
              <figure class="image is-64x64 mr-3">
                <img :src="mainTradeInImage" style="object-fit: cover; border-radius: 6px; height: 100%;" alt="Trade-In">
              </figure>
              <div>
                <p class="has-text-weight-semibold">{{ tradeIn.tradeInProductName }}</p>
                <router-link :to="'/productos/detalle/' + tradeIn.tradeInProductId" class="is-size-7 has-text-info">
                  Ver producto #{{ tradeIn.tradeInProductId }}
                </router-link>
              </div>
            </div>
            <div v-else>
              <p class="has-text-weight-semibold">{{ tradeIn.tradeInProductName }}</p>
              <router-link :to="'/productos/detalle/' + tradeIn.tradeInProductId" class="is-size-7 has-text-info">
                Ver producto #{{ tradeIn.tradeInProductId }}
              </router-link>
            </div>

            <div class="mt-3" style="font-size: 12px;">
              <p v-if="tradeIn.market_price">
                <strong>Precio mercado:</strong>
                {{ formatMoney(tradeIn.market_price) }}
              </p>
              <p v-if="tradeIn.proposal_amount">
                <strong>Propuesta final:</strong>
                {{ formatMoney(tradeIn.proposal_amount) }}
              </p>
            </div>
          </div>
        </div>

        <div class="column is-6">
          <div class="box" style="border-left: 4px solid #48c78e;">
            <p class="has-text-weight-bold is-size-6 mb-2">
              <span class="material-icons" style="font-size: 16px; vertical-align: middle; margin-right: 4px; color: #48c78e;">upgrade</span>
              ✨ Nuevo Equipo Solicitado
            </p>
            <div v-if="tradeIn.targetProductId">
              <div class="is-flex is-align-items-center mb-3" v-if="tradeIn.targetImage">
                <figure class="image is-64x64 mr-3">
                  <img :src="tradeIn.targetImage" style="object-fit: cover; border-radius: 6px; height: 100%;" alt="Target">
                </figure>
                <div>
                  <p class="has-text-weight-semibold">{{ tradeIn.targetProductName }}</p>
                  <router-link :to="'/inventario/detalle/' + tradeIn.targetProductId" class="is-size-7 has-text-info">
                    Ver inventario #{{ tradeIn.targetProductId }}
                  </router-link>
                </div>
              </div>
              <div v-else>
                <p class="has-text-weight-semibold">{{ tradeIn.targetProductName }}</p>
                <router-link :to="'/inventario/detalle/' + tradeIn.targetProductId" class="is-size-7 has-text-info">
                  Ver inventario #{{ tradeIn.targetProductId }}
                </router-link>
              </div>
              <p class="mt-2" style="font-size: 12px;">
                <strong>Precio (GivU):</strong>
                {{ formatMoney(tradeIn.targetProductPrice) }}
              </p>
            </div>
            <p v-else class="has-text-grey is-size-7">Sin equipo de upgrade asignado todavía.</p>
          </div>
        </div>
      </div>

      <div class="box mt-2">
        <p class="has-text-weight-bold mb-3">Progreso de la Operación</p>
        <div class="is-flex is-flex-wrap-wrap" style="gap: 8px;flex-flow: wrap;">
          <span class="tag is-medium" :class="tradeIn.pdf_date ? 'is-success' : 'is-light'">
            {{ tradeIn.pdf_date ? '✅' : '⏳' }} Carta CES
          </span>
          <span class="tag is-medium" :class="tradeIn.date_receipt ? 'is-success' : 'is-light'">
            {{ tradeIn.date_receipt ? '✅' : '⏳' }} Dispositivo Recibido
          </span>
          <span class="tag is-medium" :class="tradeIn.diagnostic_date ? 'is-success' : 'is-light'">
            {{ tradeIn.diagnostic_date ? '✅' : '⏳' }} Diagnóstico
          </span>
          <span class="tag is-medium" :class="tradeIn.proposal_amount ? 'is-success' : 'is-light'">
            {{ tradeIn.proposal_amount ? '✅' : '⏳' }} Propuesta enviada
          </span>
          <span class="tag is-medium" :class="tradeIn.sellId ? 'is-success' : 'is-light'">
            {{ tradeIn.sellId ? '✅' : '⏳' }} Pago recibido
          </span>
          <span class="tag is-medium" :class="tradeIn.closed_date ? 'is-success' : 'is-light'">
            {{ tradeIn.closed_date ? '✅' : '⏳' }} Nuevo equipo enviado
          </span>
        </div>
      </div>
    </div>

    <div v-else class="notification is-warning is-light">
      <p>No se encontró una operación de Trade-In asociada a este producto.</p>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'TradeInTab',
  props: {
    upgradeId: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      loading: false,
      tradeIn: null
    }
  },
  computed: {
    mainTradeInImage () {
      if (!this.tradeIn || !this.tradeIn.tradeInImages || this.tradeIn.tradeInImages.length === 0) return null
      const main = this.tradeIn.tradeInImages.find(i => i.main)
      return main ? main.url : this.tradeIn.tradeInImages[0].url
    },
    statusTagStyle () {
      const s = this.tradeIn ? this.tradeIn.logisticStatus : ''
      if (s.includes('Completado')) return 'background-color: #ebfff3; color: #257953; font-weight: 600;'
      if (s.includes('Pago')) return 'background-color: #fffbeb; color: #8a6d00; font-weight: 600;'
      if (s.includes('Recibido')) return 'background-color: #eef3ff; color: #2151b5; font-weight: 600;'
      return 'background-color: #f5f5f5; color: #555;'
    }
  },
  methods: {
    ...mapActions(['getTradeInDetail']),
    formatMoney (val) {
      if (!val && val !== 0) return 'N/A'
      return parseFloat(val).toLocaleString('es-MX', {
        style: 'currency',
        currency: 'MXN',
        minimumFractionDigits: 0
      })
    },
    async fetchData () {
      if (!this.upgradeId) return
      this.loading = true
      try {
        const res = await this.getTradeInDetail(this.upgradeId)
        if (res && res.payload) {
          this.tradeIn = res.payload
        }
      } catch (e) {
        console.error('Error cargando Trade-In tab:', e)
      } finally {
        this.loading = false
      }
    }
  },
  mounted () {
    this.fetchData()
  },
  watch: {
    upgradeId () {
      this.fetchData()
    }
  }
}
</script>

<style scoped>
.spin {
  animation: spin 1s linear infinite;
}
@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>
